export default "__VITE_ASSET__b7e633d3__"